import React, { useState } from "react"
import img from "../images/pricing.jpg"
import Back from "../common/Back"
import { API_BASE } from "../../lib/api"
import "./contact.css"

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess(false)
    setLoading(true)
    try {
      const res = await fetch(`${API_BASE}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Something went wrong")
        return
      }
      setSuccess(true)
      setFormData({ name: "", email: "", subject: "", message: "" })
    } catch (err) {
      setError("Could not send. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <section className='contact mb'>
        <Back name='Contact Us' title='Get Helps & Friendly Support' cover={img} />
        <div className='container'>
          <form className='shadow' onSubmit={handleSubmit}>
            <h4>Fill up the form</h4>
            <br />
            {success && <p style={{ color: "var(--primary-color, #25b579)", marginBottom: "1rem" }}>Thanks! We&apos;ve received your message and will get back to you soon.</p>}
            {error && <p style={{ color: "#c00", marginBottom: "1rem" }}>{error}</p>}
            <div>
              <input
                type='text'
                name='name'
                placeholder='Name'
                value={formData.name}
                onChange={handleChange}
                required
              />
              <input
                type='email'
                name='email'
                placeholder='Email'
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <input
              type='text'
              name='subject'
              placeholder='Subject'
              value={formData.subject}
              onChange={handleChange}
            />
            <textarea
              name='message'
              cols='30'
              rows='10'
              placeholder='Your message'
              value={formData.message}
              onChange={handleChange}
              required
            />
            <button type='submit' disabled={loading}>
              {loading ? "Sending…" : "Submit Request"}
            </button>
          </form>
        </div>
      </section>
    </>
  )
}

export default Contact
